/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-01-21T19:19:46-08:00
* @Email:  daniel@reflexmedia.com
* @Last modified by:   Daniel
* @Last modified time: 2017-03-27T17:12:23-07:00
*/



import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { color, textColor } from '../../style';
import { Link } from 'react-router';

const style = StyleSheet.create({
  textLink: {
    color: color.BRAND_1,

    [':hover']: {
      textDecoration: 'underline'
    }
  },


  red: {
    ...textColor.RED
  }
});

const TextLink = (props) => {

  return (
    <Link
      className={css(style.textLink, props.color && style[props.color])}
      {...props}
      >
      {props.children}
    </Link>
  )
}

export default TextLink;



// WEBPACK FOOTER //
// ./src/components/common/TextLink.jsx